<template>
  <div v-if="cvCommentState">
    <div class="cv-comment-guide" />
    <div class="cv-comment-bubble-content flex-between">
      <span>点评功能上线，可邀请好友帮忙改简历</span>
      <span class="cv-comment-btn" @click.stop="handleClose">我知道了</span>
    </div>
<!--    <div class="cv-comment-guide-btn flex-center" @click.stop="handleClose">我知道了</div>-->
    <div class="cv-comment-guide-mask" />
  </div>
</template>

<script>
  export default {
    name: 'cv-comment-guide',
    props: {
      cvCommentState: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    mounted() {
    },
    computed: {},
    watch: {},
    components: {},
    methods: {
      handleClose() {
        this.$db.ls.set('cvComment', true)
        this.$emit('handleClose')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global/variable";
  @import "../../assets/scss/global/mixin";
  .cv-comment-guide {
    position: absolute;
    @include fixed-bottom(26px);
    width: 58px;
    left: 38px;
    height: 75px;
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.7) 0 0 0 100vh;
    z-index: 399;
  }
  .cv-comment-bubble-content {
    @include bubble(calc(100vw - 32px), 52px, #fff, 1);
    position: absolute !important;
    left: 20px;
    color: $color-title;
    z-index: 402;
    border-radius: 6px;
    padding: 0 16px;
    @include fixed-bottom(118px);
    &::before {
      left: 38px;
      transform: translateX(0);
      border-top-width: 10px;
    }
  }
  .cv-comment-guide-btn {
    position: fixed;
    @include fixed-bottom(27px);
    width: 100px;
    height: 36px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 402;
    color: $color-title;
    background-color: $color-light;
    border-radius: 6px;
  }
  .cv-comment-btn {
    color: #4183FF;
    text-decoration: underline;
  }
  .cv-comment-guide-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 401;
    background-color: transparent;
  }
</style>